<h1 mat-dialog-title>Edit Details</h1>
<div mat-dialog-content>
    <ngx-spinner type="ball-scale-multiple" size="medium" [name]="blockLoader"></ngx-spinner>
    <div class="fl">
        <mat-label class="mat-label"><span class="mat-label">Program Name</span></mat-label>
        <input [(ngModel)]="jsonData.name" matInput required>
    </div>

    <div class="fl">
        <mat-label class="mat-label">Program Description</mat-label>
        <textarea name="Description" [(ngModel)]="jsonData.description" id="" cols="30" rows="3"></textarea>
    </div>

    <div id="edit-toggle-div">
        Display in categories : <mat-slide-toggle color="accent" [(ngModel)]="jsonData.isPublished"></mat-slide-toggle>
    </div>

    <div class="fl">
        <mat-label class="mat-label">Program Image</mat-label>
        <div class="img">
            <input type="file" (change)="onFileChange($event, 'programImage')" accept=".png,.jpg" required />
        </div>
        <div *ngIf="jsonData?.programImage">
            <img class="library_img" [src]="jsonData.programImage" />
        </div>
    </div>

    <div class="fl">
        <mat-label class="mat-label">Landscape Image</mat-label>
        <div class="img">
            <input type="file" (change)="onFileChange($event, 'landscapeImage')" accept=".png,.jpg" required />
        </div>
        <div *ngIf="jsonData?.landscapeImage">
            <img class="library_img" [src]="jsonData.landscapeImage" />
        </div>
    </div>


    <div class="fl">
        <mat-label class="mat-label">Select Category</mat-label>
        <mat-select [(value)]="jsonData.category.id" (selectionChange)="changeCategory($event.value)">
            <mat-option *ngFor="let cat of categories" [value]="cat.id">{{cat.name}}</mat-option>
        </mat-select>
    </div>

    <div class="fl" *ngIf="subCategories.length || jsonData.subCategory.id">
        <mat-label class="mat-label">Select Sub Category</mat-label>
        <mat-select [(value)]="jsonData.subCategory.id" (selectionChange)="changeSubCategory($event.value)">
            <mat-option *ngFor="let subCat of subCategories" [value]="subCat.id">{{subCat.name}}</mat-option>
        </mat-select>
    </div>

    <div class="fl">
        <mat-label class="mat-label">Select Difficulty Level</mat-label>
        <mat-select [(ngModel)]="jsonData.difficultyLevel">
            <mat-option value="easy">Easy</mat-option>
            <mat-option value="medium">Medium</mat-option>
            <mat-option value="hard">Hard</mat-option>
        </mat-select>
    </div>

    <div class="fl">
        <mat-label class="mat-label">Course Time</mat-label>
        <input type="text" [(ngModel)]="jsonData.courseTime" placeholder="hh:mm" matInput required>
    </div>

    <button mat-button cdkFocusInitial (click)="addSection()">Add Section</button>
    <div *ngIf="jsonData?.sections?.length" class="section">
        <ng-container *ngFor="let section of jsonData.sections; let sectionIndex = index">
            <div class="secDiv">
                <div class="fl">
                    <mat-label class="mat-label">Name</mat-label>
                    <input [(ngModel)]="section.name" matInput required>
                </div>

                <div class="fl">
                    <mat-label class="mat-label">Description</mat-label>
                    <textarea name="Description" [(ngModel)]="section.description" id="" cols="30" rows="3"></textarea>
                </div>

                <button (click)="addUnit(sectionIndex)" class="unit-btn">Add Unit +</button>
                <button (click)="removeSection(sectionIndex)" class="removeBtn">Remove Section</button>
                <div *ngIf="section?.menu?.length">
                    <ng-container *ngFor="let menu of section.menu; let menuIndex=index">
                        <div class="unit-div">
                            <div class="fl">
                                <mat-label class="mat-label">Unit name</mat-label>
                                <input [(ngModel)]="menu.name" matInput required>
                            </div>

                            <div class="fl">
                                <mat-label class="mat-label">Points</mat-label>
                                <input [(ngModel)]="menu.pts" type="number" matInput required>
                            </div>

                            <div class="fl">
                                <mat-label class="mat-label">DOSE Number</mat-label>
                                <input [(ngModel)]="menu.dfs" type="number" matInput required>
                            </div>

                            <div class="fl">
                                <mat-label class="mat-label">Unit Type</mat-label>
                                <mat-select [value]="getSmallCaseUnitType(menu.type)"
                                    (selectionChange)="changeUnitType($event.value, sectionIndex, menuIndex)">
                                    <mat-option *ngFor="let type of unitType"
                                        [value]="getSmallCaseUnitType(type)">{{type}}</mat-option>
                                </mat-select>
                            </div>

                            <div class="fl"
                                *ngIf="apiCategory.length && (jsonData.sections[sectionIndex].menu[menuIndex].type === 'Video' || jsonData.sections[sectionIndex].menu[menuIndex].type === 'Quiz' || jsonData.sections[sectionIndex].menu[menuIndex].type === 'video' || jsonData.sections[sectionIndex].menu[menuIndex].type === 'quiz')">
                                <mat-label class="mat-label">Select Category</mat-label>
                                <mat-select [(value)]="menu.categoryId"
                                    (selectionChange)="changeApiCategoryType($event.value, sectionIndex, menuIndex)">
                                    <mat-option *ngFor="let cat of apiCategory"
                                        [value]="cat.id">{{cat.name}}</mat-option>
                                </mat-select>
                            </div>

                            <div class="fl"
                                *ngIf="(jsonData.sections[sectionIndex].menu[menuIndex].type === 'Video' || jsonData.sections[sectionIndex].menu[menuIndex].type === 'Quiz' || jsonData.sections[sectionIndex].menu[menuIndex].type === 'video' || jsonData.sections[sectionIndex].menu[menuIndex].type === 'quiz')">
                                <mat-label class="mat-label">Select Course</mat-label>
                                <mat-select [(value)]="menu.courseid"
                                    (selectionChange)="changeIgniteCourseType($event.value, sectionIndex, menuIndex)">
                                    <mat-option *ngFor="let course of igniteCourses[sectionIndex][menuIndex]"
                                        [value]="course.courseid">{{course.name}}</mat-option>
                                </mat-select>
                            </div>

                            <div class="fl"
                                *ngIf="jsonData.sections[sectionIndex].menu[menuIndex].type === 'Download' || jsonData.sections[sectionIndex].menu[menuIndex].type === 'download'">
                                <mat-label class="mat-label"> Portrait Image</mat-label>
                                <div class="img">
                                    <input type="file" (change)="onDownloadFileChange($event, 'portraitImage', sectionIndex, menuIndex)"
                                        accept=".png,.jpg" required />
                                </div>
                                <div
                                    *ngIf="jsonData.sections[sectionIndex].menu[menuIndex].metadata.documents[0]?.portraitImage">
                                    <img class="library_img"
                                        [src]="jsonData.sections[sectionIndex].menu[menuIndex].metadata.documents[0].portraitImage" />
                                </div>
                            </div>

                            <div class="fl"
                                *ngIf="jsonData.sections[sectionIndex].menu[menuIndex].type === 'Download' || jsonData.sections[sectionIndex].menu[menuIndex].type === 'download'">
                                <mat-label class="mat-label"> Landscape Image</mat-label>
                                <div class="img">
                                    <input type="file" (change)="onDownloadFileChange($event, 'landscapeImage', sectionIndex, menuIndex)"
                                        accept=".png,.jpg" required />
                                </div>
                                <div
                                    *ngIf="jsonData.sections[sectionIndex].menu[menuIndex].metadata.documents[0]?.landscapeImage">
                                    <img class="library_img"
                                        [src]="jsonData.sections[sectionIndex].menu[menuIndex].metadata.documents[0].landscapeImage" />
                                </div>
                            </div>

                            <div class="fl"
                                *ngIf="jsonData.sections[sectionIndex].menu[menuIndex].type === 'Download' || jsonData.sections[sectionIndex].menu[menuIndex].type === 'download'">
                                <mat-label class="mat-label">Download URL</mat-label>
                                <input
                                    [(ngModel)]="jsonData.sections[sectionIndex].menu[menuIndex].metadata.documents[0].link"
                                    type="text" matInput required>
                            </div>

                            <div class="fl"
                                *ngIf="jsonData.sections[sectionIndex].menu[menuIndex].type === 'Download' || jsonData.sections[sectionIndex].menu[menuIndex].type === 'download'">

                                <input type="file" (change)="onFileSelected($event)">
                                <button (click)="uploadDocument(sectionIndex, menuIndex)">Upload Document</button>
                            </div>

                            <!-- vtt file upload code -------------- -->

                            <div class="vtt_accordion" *ngIf="menu.type === 'video'">
                                <div class="accordion accordion-flush" id="accordionFlushExample">
                                    <div class="accordion-item" *ngFor="let topic of menu.metadata.topics; let topicIndex = index">
                                    <h2 class="accordion-header">
                                        <div style="display: flex;align-items: center;">
                                            <div class="count_value">
                                                {{ topicIndex + 1 }}
                                            </div>

                                            <div class="actions-btns">
                                                <div class="vtt-btn vtt-upload-btn">
                                                Upload VTT file
                                                <input type="file" (change)="onVttFileSelected($event, jsonData, sectionIndex, menuIndex, topicIndex)" accept=".vtt">
                                                </div>
                                                <div style="margin-inline: 15px;font-size: 14px;">or</div>
                                                <button class="vtt-btn vtt-generate-btn" [disabled]="vttGenerationDetails.status === 'pending' && vttGenerationDetails.techStatus !== '' && vttGenerationDetails.message !== ''" (click)="generateVttFile(topic.videoLocation, sectionIndex, menuIndex, topicIndex, $event.target)">{{ getVttButtonText(sectionIndex, menuIndex, topicIndex) }}</button>
                                            </div>
                                        </div>
                                        <button (click)="fetchVttFile(topic.vttFile, sectionIndex, topicIndex, menuIndex)" class="accordion-button collapsed" type="button" data-bs-toggle="collapse" [attr.data-bs-target]="'#collapse-' + sectionIndex + '-' + topicIndex + '-' + menuIndex" aria-expanded="false" [attr.aria-controls]="'collapse-' + sectionIndex + '-' + topicIndex + '-' + menuIndex"></button>

                                    </h2>
                                    <div [attr.id]="'collapse-' + sectionIndex + '-' + topicIndex + '-' + menuIndex" class="accordion-collapse collapse" [attr.aria-labelledby]="'heading-' + sectionIndex + '-' + topicIndex + '-' + menuIndex" data-bs-parent="#accordionFlushExample">
                                        <div class="accordion-body">
                                            <textarea [(ngModel)]="vttContents[sectionIndex + '-' + menuIndex + '-' + topicIndex]" name="vttcontent" [id]="topicIndex" placeholder="No VTT file content available. Start typing here..." (input)="onTextChange($event, topic)"></textarea>
                                            <!-- <div style="padding: 10px; font-size: 13px;" [innerText]="vttContents[menuIndex + '-' + topicIndex]"></div> -->
                                        </div>
                                    </div>
                                    </div>
                                </div>
                            </div>

                            <!-- vtt file upload code -------------- -->

							<div>
                                <button (click)="removeUnit(sectionIndex, menuIndex)" class="unit-btn" id="remove-unit-btn">Remove
                                    Unit</button>
                            </div>

                        </div>

                    </ng-container>
                </div>
            </div>
        </ng-container>

    </div>

</div>

<div mat-dialog-actions style="display: flex;justify-content: flex-end;">
    <button mat-button cdkFocusInitial (click)="deleteProgram()">Delete</button>
    <button mat-button mat-dialog-close>Cancel</button>
    <button mat-button cdkFocusInitial (click)="saveProgram()">Save</button>
</div>